import Vue from 'vue';

export default Vue.component('section-pointup-divider', {
  template: require('./template.html'),
  name: 'section-pointup-divider',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/point-up/index.js